import { Component, Inject, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { FieldTree, form, required } from '@angular/forms/signals'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { NaytettavaKirjaus } from '../kirjanpito.component'

import { DateService } from '@lemon/core/service/date.service'

import { arvonMuutokset } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'
import { FormValidationService } from 'app/_jaettu-angular/service/form-validation.service'
import { Asiakas } from 'app/_jaettu-lemonator/model/asiakas'
import { AsiakasJaettuService } from 'app/_jaettu-lemonator/service/asiakas-jaettu.service'

interface PaivamaaraLomake {
  kirjauksenPvm: Date | null
}

export interface KirjausMuutaPaivamaaraDialogData {
  naytettavaKirjaus: NaytettavaKirjaus
  asiakas: Asiakas
}

@Component({
  templateUrl: './kirjaus.muuta-pvm.dialog.html',
  styleUrls: ['./kirjaus.muuta-pvm.dialog.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class KirjausMuutaPaivamaaraDialog implements OnInit {
  lomake: FieldTree<PaivamaaraLomake>
  ensimmainenPaiva: Date = new Date(2015, 1, 1)
  viimeinenPaiva: Date = new Date()

  private uusiPaivamaara: number = null

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: KirjausMuutaPaivamaaraDialogData,
    private _dialogRef: MatDialogRef<KirjausMuutaPaivamaaraDialog>,
    private _dateService: DateService,
    private _asiakasJaettuService: AsiakasJaettuService,
    private _formValidationService: FormValidationService,
  ) {
    const asDate = this._dateService.numberToDate(this.data.naytettavaKirjaus.uusiPaivamaara || this.data.naytettavaKirjaus.kirjaus.p)
    this.lomake = form(signal<PaivamaaraLomake>({ kirjauksenPvm: asDate }), polku => {
      required(polku.kirjauksenPvm)
    })
    arvonMuutokset(this.lomake.kirjauksenPvm).subscribe(value => {
      this.uusiPaivamaara = this._dateService.localDateToNumber(this._dateService.dateToLocalDate(value))
    })

    const ensimmainenTilikausi = this._asiakasJaettuService.annaEnsimmainenTilikausi(data.asiakas)
    if (ensimmainenTilikausi) {
      this.ensimmainenPaiva = this._dateService.localDateToDate(ensimmainenTilikausi.alkaa)
    }

    const viimeinenTilikausi = this._asiakasJaettuService.annaViimeinenTilikausi(data.asiakas)
    if (viimeinenTilikausi) {
      this.viimeinenPaiva = this._dateService.localDateToDate(viimeinenTilikausi.loppuu)
    }
  }

  ngOnInit() {}

  muuta() {
    if (this.lomake().invalid()) {
      this._formValidationService.merkitseKokoLomakeKosketuksi(this.lomake)
      return
    }

    if (!this.uusiPaivamaara || this.data.naytettavaKirjaus.kirjaus.p === this.uusiPaivamaara) {
      this.data.naytettavaKirjaus.uusiPaivamaara = null
      this.data.naytettavaKirjaus.tilitapahtumanPvm = this._dateService.muotoileNumberPaiva(this.data.naytettavaKirjaus.kirjaus.p, 'fi')
    } else {
      this.data.naytettavaKirjaus.uusiPaivamaara = this.uusiPaivamaara
      this.data.naytettavaKirjaus.tilitapahtumanPvm = this._dateService.muotoileNumberPaiva(this.uusiPaivamaara, 'fi')
    }
    this._dialogRef.close(true)
  }
}
